import { DeleteOutlined, FormOutlined } from '@ant-design/icons';
import {
  Button as ButtonAntd,
  Card as CardAntd,
  Input as InputAntd,
  Row as RowAntd,
  Spin as SpinAntd,
  Table as TableAntd,
} from 'antd';
import styled from 'styled-components';

export const Content = styled(RowAntd)`
  padding: 20px 30px;
`;

export const IncluirButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  width: 128px;
  height: 32px;
`;

export const EditarButton = styled(ButtonAntd)`
  color: #6bbc60;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
`;

export const Table = styled(TableAntd)`
  .ant-table {
    border-right: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 12px;
    height: 44px;
    background: #f5f5f6;
    border: 1px solid #dfdfdf;
  }

  table tr > td {
    padding: 0px 16px;
    font-size: 12px;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    height: 56px;
  }
`;

export const FiltroInput = styled(InputAntd)`
  width: 188px;
  margin-bottom: 8px;
  display: block;

  .ant-table-filter-trigger-container {
    position: 'relative';
  }
`;

export const Title = styled.span`
  display: block;
`;

export const Container = styled.div`
  width: 100%;
  background: white;
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const LabelCheckbox = styled.span`
  color: #4f4f4f !important;
`;

export const Card = styled(CardAntd)`
  margin: 1px !important;
  margin-bottom: 16px !important;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(217, 217, 217, 1);
  padding: 10px 16px;

  .ant-card-body {
    padding: 16px !important;

    .col-card {
      margin-bottom: 20px;
    }

    .col-card:last-child {
      margin-bottom: 0px !important;
    }
  }
`;

export const TitleCard = styled.span`
  text-transform: capitalize;
  font-weight: 700;
  font-size: 14px;
  font-color: #6a6a6a;
`;

export const SubTitleCard = styled.span`
  text-transform: capitalize;
  font-weight: 400;
  font-size: 14px;
  fontcolor: #6a6a6a;
`;

export const FormOutlinedIcon = styled(FormOutlined)`
  font-size: 20px;
  color: #5bc0de;
`;

export const DeleteOutlinedIcon = styled(DeleteOutlined)`
  font-size: 20px;
  color: #d85450;
`;

export const RowPagination = styled(RowAntd)`
  padding: 0 24px;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
`;

export const Spin = styled(SpinAntd)`
  max-height: 100% !important;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;
